import { render, staticRenderFns } from "./XDialog.vue?vue&type=template&id=ff4d72a2&"
import script from "./XDialog.vue?vue&type=script&lang=js&"
export * from "./XDialog.vue?vue&type=script&lang=js&"
import style0 from "./XDialog.vue?vue&type=style&index=0&id=ff4d72a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports